<script setup>
import { useI18n } from 'vue-i18n';
import AppointmentsBlock from 'dashboard/components-next/pipeline/AppointmentsBlock.vue';

defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['itemUpdated']);

const { t } = useI18n();
</script>

<template>
  <div class="space-y-6">
    <div class="flex items-center justify-between">
      <h3 class="text-base font-semibold text-n-slate-12">
        {{ t('PIPELINE.SCHEDULED.TITLE') }}
      </h3>
    </div>

    <AppointmentsBlock
      :pipeline-card-id="item.id"
      :contact-id="item.contact?.id || null"
      @appointment-created="emit('itemUpdated')"
    />
  </div>
</template>
